'use strict';

var _ = require('lodash');

/**
 * Flight Analysis - DA Cabin tab - Grid
 */
var FlightCabinDAGridTransformerFactory = function FlightCabinDAGridTransformerFactory(DataTransformer, momentService, dtdFilteringService) {
  function FlightCabinDAGridTransformer() {
    DataTransformer.call(this);
    this.sourceType = ['cabin-da'];
    this.targetType = ['cabin-flight-da-analysis', 'profile-chart-add-flight-panel-dropdowns'];
    this.priority = 1;
  }
  FlightCabinDAGridTransformer.prototype = Object.create(DataTransformer.prototype);
  FlightCabinDAGridTransformer.constructor = FlightCabinDAGridTransformer;
  FlightCabinDAGridTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.targetType.indexOf(targetType) > -1 && this.sourceType.indexOf(sourceType) > -1;
  };
  FlightCabinDAGridTransformer.prototype.isCacheable = function () {
    return true;
  };
  FlightCabinDAGridTransformer.prototype.getCacheKey = function () {
    return this.sourceType.join('-') + '-' + this.targetType.join('-');
  };
  FlightCabinDAGridTransformer.prototype.transform = function (data, metric, metricDescriptor) {
    var dtdCriteria = metricDescriptor && metricDescriptor.params && metricDescriptor.params.dtdCriteria || [];
    var memorizedMomentOfDepartureDate = _.memoize(getMomentOfDate);
    var memorizedMomentOfArrivalTime = _.memoize(getMomentOfTime);
    var memorizedMomentOfDeparture = _.memoize(getMomentOfTime);
    var memorizedMomentOfLastProcessedDate = _.memoize(getMomentOfDate);
    var transformData = function transformData(legCabins) {
      var result = [];
      for (var i = 0, length = legCabins.length; i < length; i++) {
        var cabin = legCabins[i];

        // skip records that contain only LY data (aka wydmuszki)
        if (_.isUndefined(cabin.flightId)) {
          continue;
        }
        var flightDepartureDateMoment = memorizedMomentOfDepartureDate(cabin.flightDepartureDate, momentService.FIELD.DEPARTURE_DATE);
        var legDepartureDateMoment = memorizedMomentOfDepartureDate(cabin.legDepartureDate, momentService.FIELD.DEPARTURE_DATE);
        var momentArrivalTime = memorizedMomentOfArrivalTime(cabin.arrivalTime, momentService.FIELD.ARRIVAL_TIME, memorizedMomentOfDepartureDate);
        var momentDepartureTime = memorizedMomentOfDeparture(cabin.departureTime, momentService.FIELD.DEPARTURE_TIME, memorizedMomentOfDepartureDate);
        var lastProcessedTimeStamp = memorizedMomentOfLastProcessedDate(cabin.lastProcessedTime, momentService.FIELD.EVENT_TIME_STAMP);
        var newEntry = {
          flightId: cabin.flightId,
          entryKey: cabin.legId + cabin.cabinCode + cabin.flightDepartureDate,
          flightNumber: cabin.flightNumber,
          flightDepartureDateMoment: flightDepartureDateMoment,
          legId: cabin.legId,
          leg: cabin.leg,
          legDepartureDateMoment: legDepartureDateMoment,
          season: cabin.season,
          departureDateDOW: cabin.departureDateDOW.substr(0, 3),
          completeNameDepartureDateDOW: cabin.departureDateDOW,
          departureTime: momentDepartureTime,
          arrivalTime: momentArrivalTime,
          equipment: cabin.equipment,
          legCabinId: cabin.legCabinId,
          cabinCode: cabin.cabinCode,
          overbookedCapacity: cabin.overbookedCapacity,
          daysToDeparture: cabin.daysToDeparture,
          bidPrice: cabin.bidPrice,
          lastProcessedTime: lastProcessedTimeStamp
        };
        var metrics = {};
        if (cabin.loadFactorMetric && cabin.bookingMetric && cabin.askMetric && cabin.rpkMetric && cabin.capacityMetric) {
          metrics = {
            seatsAvail: cabin.seatsAvail,
            //loadFactor
            currentLoadFactor: cabin.loadFactorMetric.currentLF,
            expectedLoadFactor: cabin.loadFactorMetric.expectedLF,
            currentSeasonLoadFactor: cabin.loadFactorMetric.currentSeasonLF,
            finalSeasonLoadFactor: cabin.loadFactorMetric.finalSeasonLF,
            adjustmentFactor: cabin.loadFactorMetric.adjustedLF,
            seasonalReferenceLoadFactorDeviation: cabin.loadFactorMetric.seasonReferenceLFDeviation,
            bvDeviationPercentage: cabin.loadFactorMetric.bvDeviation,
            legLoadFactor: cabin.loadFactorMetric.legLF,
            bvDeviationAbsolute: cabin.loadFactorMetric.bvDeviationAbsolute,
            //booking
            groupBooking: cabin.bookingMetric.groupBkg,
            totalBooking: cabin.bookingMetric.totalBkg,
            expectedBooking: cabin.bookingMetric.expectedBkg,
            currentSeasonBooking: cabin.bookingMetric.currentSeasonBkg,
            finalSeasonBooking: cabin.bookingMetric.finalSeasonBkg,
            //ask
            currentASK: cabin.askMetric.currentASK,
            currentSeasonASK: cabin.askMetric.currentSeasonASK,
            finalSeasonASK: cabin.askMetric.finalSeasonASK,
            //rpk
            currentRPK: cabin.rpkMetric.currentRPK,
            currentSeasonRPK: cabin.rpkMetric.currentSeasonRPK,
            expectedRPK: cabin.rpkMetric.expectedRPK,
            finalSeasonRPK: cabin.rpkMetric.finalSeasonRPK,
            //capacity
            currentCapacity: cabin.capacityMetric.currentCapacity,
            currentSeasonCapacity: cabin.capacityMetric.currentSeasonCapacity,
            expectedCapacity: cabin.capacityMetric.expectedCapacity,
            finalSeasonCapacity: cabin.capacityMetric.finalSeasonCapacity,
            capacityDeviation: cabin.capacityMetric.capacityDeviation
          };
        }
        var entryWithMetrics = _.extend(newEntry, metrics);
        result.push(entryWithMetrics);
      }
      return result;
    };
    var legCabins = data.domain.legCabins || data.domain.results;
    var filteredLegCabins = dtdCriteria && dtdCriteria.length ? dtdFilteringService.filterByDtd(legCabins, dtdCriteria) : legCabins;
    return transformData(filteredLegCabins);
  };
  function getMomentOfDate(date, field, stringFormat) {
    return momentService.of(date, field, stringFormat);
  }
  function getMomentOfTime(date, field, memorizedMomentOfDate) {
    return memorizedMomentOfDate(date, field, 'HHmm');
  }
  return FlightCabinDAGridTransformer;
};
FlightCabinDAGridTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService', 'DtdFilteringService'];
module.exports = FlightCabinDAGridTransformerFactory;